module.exports = __webpack_public_path__ + "static/media/Bonsly_gaussian2.9081f3e8.png";